import React, { useState } from 'react';
import { App, Button, Col, Form, Input, Popconfirm, Row, Select, Upload } from 'antd';
import { Box, Stack, Grid, Table, Dialog, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import InputLabel from 'components/InputLabel/index';
import { HolderOutlined, UploadOutlined, CloseOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { DEPLOYENVIRONMENT, FILE_PORT } from 'apiConfig';
import deleteIcon from 'assets/images/table-icons/delete_red.svg';
import viewIcon from 'assets/images/table-icons/view_blue.svg';
import pdfIcon from 'assets/images/icons/pdf_red.svg';
import { v4 as uuid } from 'uuid';
import dayjs from 'dayjs';
import { CSS } from '@dnd-kit/utilities';
import { closestCenter, DndContext } from '@dnd-kit/core';
import { SortableContext, useSortable } from '@dnd-kit/sortable';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import PDF from 'pages/Awareness/PDF';

const getDate = (date) => {
	const { message: messageApi } = App.useApp();
	if (date) {
		const formateDate = dayjs(date).format('YYYY-MM-DD');
		return formateDate;
	}
};

const AgreementFiles = ({ screen }) => {
	const form = Form.useFormInstance();
	const [showModal, setShowModal] = useState(false);
	const [pdfLink, setPdfLink] = useState({ link: null, name: null });
	const { accessToken } = useSelector((state) => state?.auth);

	const getFileSize = (index) => {
		const fileJson = form.getFieldValue(['agreementFiles', index, 'file']);
		const file = fileJson ? JSON.parse(fileJson) : null;

		const bytes = file?.[0]?.size;

		if (file && bytes) {
			if (bytes === 0) return '0 Bytes';
			const k = 1024;
			const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
			const i = Math.floor(Math.log(bytes) / Math.log(k));
			const size = bytes / Math.pow(k, i);
			return `${size.toFixed(2)} ${sizes[i]}`;
		}
	};

	const beforeUpload = (file) => {
		const isPdf = file.type === 'application/pdf';
		if (!isPdf) {
			messageApi.error('You can only upload PDF files!');
			return Upload.LIST_IGNORE;
		}

		const isLt5M = file.size / 1024 / 1024 < 5;
		if (!isLt5M) {
			messageApi.error('File must be smaller than 5MB!');
			return Upload.LIST_IGNORE;
		}

		return true; // accept file
	};

	const handleDragEnd = (event, fields, fieldsOpt) => {
		const { active, over } = event;

		if (active?.id && over?.id && active?.id !== over?.id) {
			const oldIndex = fields.findIndex((field) => `${field.key}` === active.id);
			const newIndex = fields.findIndex((field) => `${field.key}` === over.id);

			// Update the state or form fields with reordered data
			fieldsOpt.move(oldIndex, newIndex);
		}
	};

	const uploadList = (file) => {
		const filesData = {
			id: uuid(),
			name: file.name.replace('.pdf', ''),
			file: JSON.stringify([file]),
		};

		const existFiles = form.getFieldValue('agreementFiles');
		if (existFiles) {
			form.setFieldsValue({ agreementFiles: [...existFiles, filesData] });
		} else {
			form.setFieldsValue({ agreementFiles: [filesData] });
		}
	};

	const pdfUploadHandler = ({ file }) => {
		const { status } = file;
		if (status === 'done') {
			if (file?.response) {
				let fileURL = file?.response?.fileURL;
				let baseURL = `https://${DEPLOYENVIRONMENT}garlicerp.com/static/`;
				let extension = '.pdf';
				file.url = baseURL + fileURL + extension;
			}
			uploadList(file);
		} else if (status === 'error') {
			messageApi.error(`${file.name} file upload failed.`);
		}
	};
	const pdfReUploadHandler = ({ file }, index, previousFile) => {
		// console.log('previousFile', previousFile);
		// console.log('index', index);

		const { status } = file;
		if (status === 'done') {
			if (file?.response) {
				let fileURL = file?.response?.fileURL;
				let baseURL = `https://${DEPLOYENVIRONMENT}garlicerp.com/static/`;
				let extension = '.pdf';
				file.url = baseURL + fileURL + extension;
			}
			const filesData = {
				id: previousFile?.id,
				name: previousFile?.name,
				file: JSON.stringify([file]),
			};

			const existFiles = form.getFieldValue('deletedFiles');
			if (existFiles) {
				form.setFieldsValue({ deletedFiles: [...existFiles, previousFile] });
			} else {
				form.setFieldsValue({ deletedFiles: [previousFile] });
			}
			// const existFiles = form.getFieldValue('agreementFiles');
			// if (existFiles) {
			// 	form.setFieldsValue({ agreementFiles: [...existFiles, filesData] });
			// } else {
			form.setFieldValue(['agreementFiles', index], filesData);
			// }
		} else if (status === 'error') {
			messageApi.error(`${file.name} file upload failed.`);
		}
	};

	const onPreviewHandler = (index) => {
		// console.log('index', index);
		const fileJson = form.getFieldValue(['agreementFiles', index, 'file']);
		const file = fileJson ? JSON.parse(fileJson) : null;

		// For redirect to module-doc-hub
		// const id = file.id;
		// const section = file.section;
		// window.open(`/modules/LMS/doc-hub/${section}?nodeId=${id}`, '_blank');

		if (file) {
			const url = file[0].url;
			const name = file[0].name;
			// console.log(file);

			setShowModal(true);
			setPdfLink({
				link: url,
				name: name,
			});
		}
	};

	const uploadComponentProps = {
		name: 'file',
		multiple: true,
		headers: { token: `Bearer ${accessToken}` },
		action: `https://${DEPLOYENVIRONMENT}file.garlicerp.com:${FILE_PORT}/lynorg-service/endpoint/file/upload-awareness`,
		showUploadList: false,
		accept: '.pdf',
		// listType: 'picture',
		className: 'upload-list-inline',
	};

	return (
		<>
			<Row gutter={[16, 0]}>
				<Form.List name="deletedFiles" noStyle>
					{(fields) => fields.map((field) => <Form.Item key={field.key} name={[field.name, 'id']} noStyle />)}
				</Form.List>
				<Form.List name="agreementFiles">
					{(fields, fieldsOpt) => (
						<>
							{screen?.toLocaleLowerCase() !== 'view' && (
								<>
									<Col xs={4}>
										<InputLabel label="Agreement File" head={true} />
									</Col>
									<Col xs={4}>
										<Upload {...uploadComponentProps} onChange={pdfUploadHandler}>
											<Button icon={<UploadOutlined />}>Upload</Button>
										</Upload>
									</Col>
								</>
							)}
							<Col xs={24}>
								<DndContext
									collisionDetection={closestCenter}
									onDragEnd={(e) => handleDragEnd(e, fields, fieldsOpt)}
									modifiers={[restrictToVerticalAxis]}
								>
									<TableContainer
										className="render-condition"
										sx={{
											'& table, & th, & td': {
												border: '1px solid #e0e0e0',
												borderCollapse: 'collapse',
											},
											'& th': {
												py: '5px',
												px: '11px',
											},
											'& td': {
												p: '5px',
											},
											'& td .ant-form-item': {
												marginBottom: '0px',
											},
											'& .condition-msg': {
												py: 3,
											},
											overflow: 'hidden',
										}}
									>
										<Table aria-label="renderConditions table">
											<TableHead>
												<TableRow>
													{screen?.toLocaleLowerCase() !== 'view' && <TableCell></TableCell>}
													<TableCell>Agreement File Name</TableCell>
													<TableCell>Agreement Type</TableCell>
													<TableCell align="center">Uploaded By</TableCell>
													<TableCell align="center">Uploaded Date</TableCell>
													<TableCell align="center">File</TableCell>
													<TableCell align="center">Action</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												{fields.length > 0 ? (
													fields.map((field) => (
														<SortableContext key={field.key} items={fields.map((field) => `${field.key}`)}>
															<SortableItem id={`${field.key}`} screen={screen}>
																<TableCell align="center">
																	<Form.Item name={[field.name, 'id']} noStyle />
																	<Form.Item name={[field.name, 'file']} noStyle />
																	<Form.Item
																		name={[field.name, 'name']}
																		rules={[{ required: true, message: 'Title is required' }]}
																	>
																		<Input
																			disabled={screen?.toLocaleLowerCase() === 'view'}
																			placeholder="Write here"
																		/>
																	</Form.Item>
																</TableCell>
																<TableCell>
																	<Form.Item
																		name={[field.name, 'agreementType']}
																		rules={[{ required: true, message: 'This Field is Required' }]}
																	>
																		<Select
																			showSearch
																			style={{ width: '100%', height: '32px', borderRadius: '4px' }}
																			filterOption={true}
																			placeholder="Select from the list"
																			optionFilterProp="children"
																			disabled={screen?.toLocaleLowerCase() === 'view'}
																		>
																			<Select.Option value="original">Original</Select.Option>
																			<Select.Option value="renewal">Renewal</Select.Option>
																			<Select.Option value="amendment">Amendment</Select.Option>
																			<Select.Option value="termination">Termination</Select.Option>
																			<Select.Option value="extension">Extension</Select.Option>
																			<Select.Option value="addendum">Addendum</Select.Option>
																		</Select>
																	</Form.Item>
																</TableCell>
																<TableCell align="center">
																	<Form.Item name={[field.name, 'uploadedBy']} noStyle />
																	<Typography component="span" style={{ fontSize: '12px' }}>
																		{form.getFieldValue(['agreementFiles', field.name, 'uploadedBy'])}
																	</Typography>
																</TableCell>
																<TableCell align="center">
																	<Form.Item name={[field.name, 'uploadedDate']} noStyle />
																	<Typography component="span" style={{ fontSize: '12px' }}>
																		{getDate(form.getFieldValue(['agreementFiles', field.name, 'uploadedDate']))}
																	</Typography>
																</TableCell>
																<TableCell align="center">
																	<Stack direction="column" justifyContent="center" alignItems="center" spacing={1}>
																		<img
																			src={pdfIcon}
																			alt="pdf"
																			width={18}
																			height={18}
																			// style={{ marginRight: '8px' }}
																		/>
																		<Typography component="span" style={{ fontSize: '12px' }}>
																			{getFileSize(field.name)}
																		</Typography>
																	</Stack>
																</TableCell>
																<TableCell align="center">
																	{screen?.toLocaleLowerCase() === 'view' && (
																		<Button
																			title="Preview"
																			onClick={() => onPreviewHandler(field.name)}
																			style={{ marginRight: '5px' }}
																		>
																			<img src={viewIcon} width={16} height={16} alt="edit" />
																		</Button>
																	)}
																	{screen?.toLocaleLowerCase() === 'edit' && (
																		<Upload
																			name="file"
																			multiple={false}
																			headers={{ token: `Bearer ${accessToken}` }}
																			action={`https://${DEPLOYENVIRONMENT}file.garlicerp.com:${FILE_PORT}/lynorg-service/endpoint/file/upload-awareness`}
																			showUploadList={false}
																			accept=".pdf"
																			beforeUpload={beforeUpload}
																			// customRequest={customRequest(info)}
																			onChange={(file) =>
																				pdfReUploadHandler(
																					file,
																					field.name,
																					form.getFieldValue(['agreementFiles', field.name])
																				)
																			}
																		>
																			<Button title="Re-Upload" style={{ marginRight: '5px' }}>
																				<UploadOutlined />
																			</Button>
																		</Upload>
																	)}
																	{(screen?.toLocaleLowerCase() === 'edit' ||
																		screen?.toLocaleLowerCase() === 'create') && (
																		<Popconfirm
																			title="Delete the attachment"
																			description="Are you sure to delete this attachment?"
																			okText="Yes"
																			cancelText="No"
																			onConfirm={() => {
																				if (screen?.toLocaleLowerCase() === 'edit') {
																					const file = form.getFieldValue(['agreementFiles', field.name]);
																					const deletedFileRange = form.getFieldValue('deletedFiles') ?? [];
																					const payload = [...deletedFileRange, file];
																					form.setFieldsValue({ deletedFiles: payload });
																				}
																				fieldsOpt.remove(field.name);
																			}}
																		>
																			<Button title="Delete">
																				<img src={deleteIcon} width={16} height={16} alt="edit" />
																			</Button>
																		</Popconfirm>
																	)}
																</TableCell>
															</SortableItem>
														</SortableContext>
													))
												) : (
													<TableRow>
														<TableCell colSpan="4" align="center" className="condition-msg">
															Click Upload Button to add Attachment
														</TableCell>
													</TableRow>
												)}
											</TableBody>
										</Table>
									</TableContainer>
								</DndContext>
							</Col>
						</>
					)}
				</Form.List>
			</Row>

			<Dialog
				fullWidth={true}
				maxWidth={'sm'}
				open={showModal}
				keepMounted
				onClose={() => setShowModal(false)}
				aria-labelledby="draggable-dialog-title"
			>
				<Box>
					<Grid container spacing={2} justifyContent="space-between" alignItems="center" sx={{ bgcolor: '#214689' }}>
						<Grid item>
							<Typography variant="subtitle2" sx={{ cursor: 'pointer', color: 'white', pl: '15px', pr: '5px' }}>
								{pdfLink?.name}
							</Typography>
						</Grid>
						<Grid item>
							<CloseOutlined style={{ bdcolor: 'white', color: 'white', padding: '15px' }} onClick={() => setShowModal(false)} />
						</Grid>
					</Grid>
				</Box>
				{pdfLink?.link && <PDF mode="Agreement" filePath={pdfLink?.link} fileName={pdfLink?.name} accessToken={accessToken} />}
			</Dialog>
		</>
	);
};

export default AgreementFiles;

function SortableItem({ id, children, screen }) {
	const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
		// background: '#fff',
		zIndex: 1,
		position: 'relative',
	};

	return (
		<TableRow ref={setNodeRef} style={style} {...attributes}>
			{screen?.toLocaleLowerCase() !== 'view' && (
				<TableCell align="center" sx={{ cursor: 'grab' }} {...listeners}>
					<HolderOutlined />
				</TableCell>
			)}
			{children}
		</TableRow>
	);
}
